import React, { useEffect, useState } from "react";
import { BlackAndWhite } from "../../../../themes/Colors";
import {
  BaseButtons,
  CloseButton,
  TextAreaInput,
  TextInputField,
} from "../../../../components/atoms";
import { LoadingPopUp, NewPrescriptionCard } from "../../../../components";
import StoreSelector from "../../../customer-portal/components/medical-history/components/store-selector/StoreSelector";

const PatientPopUp = ({
  display,
  onCloseClick,
  loading,
  setLoading,
  setSelectedPatient,
  setPatientPop,
  width,
}) => {
  const [data, setData] = useState(null);
  const [patientInfo, setPatientInfo] = useState(null);
  const [medicalCheck, setMedicalCheck] = useState(null);
  const [displayInfo, setDisplayInfo] = useState("Prescriptions");
  const [selectedPrescription, setSelectedPrescription] = useState("Approved");

  const [section21Data, setSection21Data] = useState(null);
  // this is the section 21 fields needed for application
  const [title, setTitle] = useState("");
  const [fullName, setFullName] = useState("");
  const [surname, setSurname] = useState("");
  const [idNumber, setIdNumber] = useState("");
  const [occupation, setOccupation] = useState("");
  const [age, setAge] = useState("");
  const [gender, setGender] = useState("");
  const [weight, setWeight] = useState("");
  const [heightInCm, setHeightInCm] = useState("");
  const [address, setAddress] = useState("");
  const [postalCode, setPostalCode] = useState("");
  const [cellNumber, setCellNumber] = useState("");
  const [alternateNumber, setAlternateNumber] = useState("");
  const [emailAddress, setEmailAddress] = useState("");
  const [diagnosis, setDiagnosis] = useState("");
  const [treatmentDetails, setTreatmentDetails] = useState("");
  const [otherConditions, setOtherConditions] = useState("");
  const [doYouSmokeCannabis, setDoYouSmokeCannabis] = useState("");
  const [anyOtherForm, setAnyOtherform] = useState("");
  const [specify, setSpecify] = useState("");

  const [currentStatus, setCurrentStatus] = useState(
    "PENDING APPLICATION REVIEW"
  );
  const [validUntil, setValidUntil] = useState(null);

  // store selection variable

  const [allStores, setAllStores] = useState([]);
  const [store, setStore] = useState(null);
  const [storeOpen, setStoreOpen] = useState(false);

  const checkForm = (sec) => {
    if (sec.section === "consent") {
      return BlackAndWhite.primary;
    } else if (sec.section === "lifestyle") {
      return BlackAndWhite.primary;
    } else if (sec.section === "medical history") {
      return BlackAndWhite.primary;
    } else if (sec.section === "occupational") {
      return BlackAndWhite.primary;
    } else {
      return BlackAndWhite.secondary;
    }
  };

  const checkForSection21andPrescriptionStatus = async () => {
    try {
      const response = await fetch(
        "https://budloungedatabase.onrender.com/requestPrescriptionUser/getSection21ForPatientAndPrescriptions",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `bearer ${token}`,
          },
          body: JSON.stringify({
            patientId: display.idDoc,
            patientUserId: display._id,
            type: "doc",
          }),
        }
      );

      const respnseData = await response.json();

      if (respnseData.success) {
        setSection21Data(respnseData.section21);
      }
    } catch (err) {
      console.log("error", err);
    }
  };

  useEffect(() => {
    if (section21Data) {
      setTitle(section21Data.title);
      setFullName(section21Data.fullNames);
      setSurname(section21Data.surname);
      setIdNumber(section21Data.idNumber);
      setOccupation(section21Data.occupation);
      setAge(section21Data.age);
      setGender(section21Data.gender);
      setWeight(section21Data.weightInKg);
      setHeightInCm(section21Data.heightInCm);
      setAddress(section21Data.address);
      setPostalCode(section21Data.postalCode);
      setCellNumber(section21Data.cellNumber);
      setAlternateNumber(section21Data.alternateNumber);
      setEmailAddress(section21Data.emailAddress);
      setDiagnosis(section21Data.diagnosis);
      setOtherConditions(section21Data.otherConditions);
      setTreatmentDetails(section21Data.treatmentDetails);
      setDoYouSmokeCannabis(section21Data.doYouSmokeCannabis);
      setAnyOtherform(section21Data.anyOtherWays);
      setSpecify(section21Data.specify);
      setCurrentStatus(section21Data.status);
      setStore({
        storeName: section21Data.storeName,
      });
      if (section21Data.validUntil) {
        setValidUntil(section21Data.validUntil);
      }
    }
  }, [section21Data]);
  useEffect(() => {
    if (display) {
      // setDisplayInfo(null);
      setPatientInfo(null);
      fetch("https://budloungedatabase.onrender.com/user/getPatintientInfo", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          patientId: display.patientId || display.idDoc,
        }),
      })
        .then((response) => {
          return response.json();
        })
        .then((resData) => {
          setDisplayInfo("Prescriptions");
          setPatientInfo(resData.data);
        });
      fetch(
        "https://budloungedatabase.onrender.com/medicalHistory/getMedicalHistoryByUser",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            id: display.patientId || display.idDoc,
          }),
        }
      )
        .then((response) => {
          return response.json();
        })
        .then((resData) => {
          setMedicalCheck(resData.lifestyleData);
        });
    }
  }, [display]);
  useEffect(() => {
    if (display) {
      checkForSection21andPrescriptionStatus();
    }
  }, [display]);

  useEffect(() => {
    if (display) {
      fetch(
        "https://budloungedatabase.onrender.com/prescription/fetchUserPrescriptions",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            id: display.patientId || display.idDoc,
          }),
        }
      )
        .then((response) => {
          return response.json();
        })
        .then((resData) => {
          setData(resData);
        });
    }
  }, [display]);
  return (
    <div
      style={{
        position: "absolute",
        overflow: "hidden",
        width: "100%",
        height: display ? "100%" : 0,
        transition: "all 0.5s",
        top: 0,
        opacity: display ? 1 : 0,
        backgroundColor: BlackAndWhite.secondary,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 50000000000000000,
      }}
    >
      <div
        style={{
          position: "relative",
          borderStyle: "solid",
          height: "100%",
          width: "100%",
          display: "flex",
          borderWidth: 0.5,
          // borderRadius: width > 899 ? 20 : null,
          overflow: "hidden",
          flexDirection: width > 899 ? "row" : "column",
        }}
      >
        {/* section one */}
        <div
          style={{
            flex: 0.35,
            overflow: width > 899 ? "hidden" : "scroll",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            backgroundColor: BlackAndWhite.primary,
            color: BlackAndWhite.secondary,
          }}
        >
          <div style={{ fontSize: 24, marginTop: 22, fontWeight: "bold" }}>
            Prescription info
          </div>
          <div style={{ fontSize: 18, marginTop: 22, width: "80%" }}>
            Name :{" "}
            {patientInfo
              ? patientInfo.firstName + " " + patientInfo.lastName
              : "loading"}
          </div>
          <div style={{ fontSize: 18, marginTop: 22, width: "80%" }}>
            status : {display ? display.approved : "loading"}
          </div>
          <div style={{ fontSize: 16, marginTop: 22, width: "80%" }}>
            requested : {display ? display.date : "loading"}
          </div>
          <div style={{ fontSize: 16, marginTop: 22, width: "80%" }}>
            diagnosis : {display ? display.diagnosis : "loading"}
          </div>
          <div style={{ fontSize: 16, marginTop: 22, width: "80%" }}>
            precription : {display ? display.prescription : "loading"}
          </div>
          <div
            style={{
              fontSize: 24,
              marginTop: 22,
              fontWeight: "bold",
              width: "80%",
              textAlign: "left",
            }}
          >
            Contact informtion
          </div>
          <div
            style={{
              fontSize: 15,
              marginTop: 22,
              width: "80%",
              textAlign: "left",
            }}
          >
            CELL NUMBER:
          </div>
          <div
            style={{
              fontSize: 17,
              marginTop: 10,
              width: "80%",
              textAlign: "left",
              fontWeight: "bold",
            }}
          >
            {patientInfo ? patientInfo.cellNumber : "loading"}
          </div>
          <div
            style={{
              fontSize: 15,
              marginTop: 22,
              width: "80%",
              textAlign: "left",
            }}
          >
            EMAIL:
          </div>
          <div
            style={{
              fontSize: 17,
              marginTop: 10,
              width: "80%",
              textAlign: "left",
              fontWeight: "bold",
            }}
          >
            {patientInfo ? patientInfo.email : "loading"}
          </div>
          <div
            style={{
              fontSize: 15,
              marginTop: 22,
              width: "80%",
              textAlign: "left",
            }}
          >
            DATE OF BIRTH:
          </div>
          <div
            style={{
              fontSize: 17,
              marginTop: 10,
              width: "80%",
              textAlign: "left",
              fontWeight: "bold",
            }}
          >
            {patientInfo ? patientInfo.dateOfBirth : "loading"}
          </div>
          <div
            style={{
              fontSize: 15,
              marginTop: 22,
              width: "80%",
              textAlign: "left",
            }}
          >
            GENDER:
          </div>
          <div
            style={{
              fontSize: 17,
              marginTop: 10,
              width: "80%",
              textAlign: "left",
              fontWeight: "bold",
            }}
          >
            {patientInfo ? patientInfo.gender : "loading"}
          </div>
        </div>
        <div
          style={{
            flex: 0.65,
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div
            style={{
              height: 60,
              width: "100%",

              display: "flex",
              justifyContent: "space-evenly",
              alignItems: "center",
              fontSize: width > 899 ? null : 12,
              marginTop: width > 899 ? null : 5,
            }}
          >
            {medicalCheck
              ? medicalCheck.map((form, index) => {
                  return form.section === "consent" ? null : (
                    <div
                      style={{
                        height: "100%",
                        width: "100%",
                        backgroundColor: displayInfo
                          ? displayInfo.section === form.section
                            ? BlackAndWhite.primary
                            : BlackAndWhite.secondary
                          : null,
                        color: displayInfo
                          ? displayInfo.section === form.section
                            ? BlackAndWhite.secondary
                            : BlackAndWhite.primary
                          : null,
                        transition: "all 0.3s",
                        cursor: "pointer",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        textAlign: "center",
                      }}
                      onClick={() => setDisplayInfo(form)}
                      key={index}
                    >
                      {form.section}
                    </div>
                  );
                })
              : null}
            <div
              style={{
                height: "100%",
                width: "100%",
                backgroundColor: displayInfo
                  ? displayInfo === "Prescriptions"
                    ? BlackAndWhite.red
                    : BlackAndWhite.secondary
                  : null,
                color: displayInfo
                  ? displayInfo === "Prescriptions"
                    ? BlackAndWhite.secondary
                    : BlackAndWhite.primary
                  : null,
                transition: "all 0.3s",
                cursor: "pointer",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
              onClick={() => setDisplayInfo("Prescriptions")}
            >
              Prescriptions
            </div>
            <div
              style={{
                height: "100%",
                width: "100%",
                backgroundColor: displayInfo
                  ? displayInfo === "section21"
                    ? BlackAndWhite.red
                    : BlackAndWhite.secondary
                  : null,
                color: displayInfo
                  ? displayInfo === "section21"
                    ? BlackAndWhite.secondary
                    : BlackAndWhite.primary
                  : null,
                transition: "all 0.3s",
                cursor: "pointer",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
              onClick={() => setDisplayInfo("section21")}
            >
              Section 21
            </div>
          </div>
          <div
            style={{
              height: displayInfo === "Prescriptions" ? 30 : 0,
              width: "100%",

              display: "flex",
              justifyContent: "space-evenly",
              alignItems: "center",
              transition: "all 0.2s",
              overflow: "hidden",
            }}
          >
            <div
              style={{
                height: "100%",
                width: "25%",
                backgroundColor: displayInfo
                  ? selectedPrescription === "Approved"
                    ? BlackAndWhite.primary
                    : BlackAndWhite.secondary
                  : null,
                color: displayInfo
                  ? selectedPrescription === "Approved"
                    ? BlackAndWhite.secondary
                    : BlackAndWhite.primary
                  : null,
                transition: "all 0.3s",
                cursor: "pointer",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                fontSize: 13,
              }}
              onClick={() => setSelectedPrescription("Approved")}
            >
              Approved
            </div>
            <div
              style={{
                height: "100%",
                width: "25%",
                backgroundColor: displayInfo
                  ? selectedPrescription === "Pending"
                    ? BlackAndWhite.primary
                    : BlackAndWhite.secondary
                  : null,
                color: displayInfo
                  ? selectedPrescription === "Pending"
                    ? BlackAndWhite.secondary
                    : BlackAndWhite.primary
                  : null,
                transition: "all 0.3s",
                cursor: "pointer",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                fontSize: 13,
              }}
              onClick={() => setSelectedPrescription("Pending")}
            >
              Pending
            </div>
            <div
              style={{
                height: "100%",
                width: "25%",
                backgroundColor: displayInfo
                  ? selectedPrescription === "Declined"
                    ? BlackAndWhite.primary
                    : BlackAndWhite.secondary
                  : null,
                color: displayInfo
                  ? selectedPrescription === "Declined"
                    ? BlackAndWhite.secondary
                    : BlackAndWhite.primary
                  : null,
                transition: "all 0.3s",
                cursor: "pointer",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                fontSize: 13,
              }}
              onClick={() => setSelectedPrescription("Declined")}
            >
              Declined
            </div>
            <div
              style={{
                height: "100%",
                width: "25%",
                backgroundColor: displayInfo
                  ? selectedPrescription === "Expired"
                    ? BlackAndWhite.primary
                    : BlackAndWhite.secondary
                  : null,
                color: displayInfo
                  ? selectedPrescription === "Expired"
                    ? BlackAndWhite.secondary
                    : BlackAndWhite.primary
                  : null,
                transition: "all 0.3s",
                cursor: "pointer",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                fontSize: 13,
              }}
              onClick={() => setSelectedPrescription("Expired")}
            >
              Expired
            </div>
          </div>
          <div style={{ flex: 1, overflow: "scroll" }}>
            {displayInfo ? (
              <>
                {displayInfo.section === "lifestyle" ? (
                  <div
                    style={{ width: "100%", height: "100%", display: "flex" }}
                  >
                    <div
                      style={{
                        width: "50%",
                        height: "100%",
                      }}
                    >
                      <div
                        style={{
                          marginTop: 20,
                          marginLeft: 20,
                          fontSize: 18,
                          fontWeight: "bold",
                        }}
                      >
                        Patient weight:
                      </div>
                      <div
                        style={{
                          marginTop: 10,
                          marginLeft: 23,
                          fontSize: 16,
                        }}
                      >
                        Answer : {displayInfo.answer1}
                      </div>
                      <div
                        style={{
                          marginTop: 20,
                          marginLeft: 20,
                          fontSize: 18,
                          fontWeight: "bold",
                        }}
                      >
                        Patient Height:
                      </div>
                      <div
                        style={{
                          marginTop: 10,
                          marginLeft: 23,
                          fontSize: 16,
                        }}
                      >
                        Answer : {displayInfo.answer2}
                      </div>
                      <div
                        style={{
                          marginTop: 20,
                          marginLeft: 20,
                          fontSize: 18,
                          fontWeight: "bold",
                        }}
                      >
                        Smoking habits:
                      </div>
                      <div
                        style={{
                          marginTop: 10,
                          marginLeft: 23,
                          fontSize: 16,
                        }}
                      >
                        Answer : {displayInfo.answer3}
                      </div>
                      <div
                        style={{
                          marginTop: 20,
                          marginLeft: 20,
                          fontSize: 18,
                          fontWeight: "bold",
                        }}
                      >
                        Drinking habits:
                      </div>
                      <div
                        style={{
                          marginTop: 10,
                          marginLeft: 23,
                          fontSize: 16,
                        }}
                      >
                        Answer : {displayInfo.answer4}
                      </div>
                      <div
                        style={{
                          marginTop: 20,
                          marginLeft: 20,
                          fontSize: 18,
                          fontWeight: "bold",
                        }}
                      >
                        How often the patinet drinks:
                      </div>
                      <div
                        style={{
                          marginTop: 10,
                          marginLeft: 23,
                          fontSize: 16,
                        }}
                      >
                        Answer : {displayInfo.answer5}
                      </div>
                      <div
                        style={{
                          marginTop: 20,
                          marginLeft: 20,
                          fontSize: 18,
                          fontWeight: "bold",
                        }}
                      >
                        Exercise habits:
                      </div>
                      <div
                        style={{
                          marginTop: 10,
                          marginLeft: 23,
                          fontSize: 16,
                        }}
                      >
                        Answer : {displayInfo.answer6}
                      </div>
                      <div
                        style={{
                          marginTop: 20,
                          marginLeft: 20,
                          fontSize: 18,
                          fontWeight: "bold",
                        }}
                      >
                        Sleeping habits:
                      </div>
                      <div
                        style={{
                          marginTop: 10,
                          marginLeft: 23,
                          fontSize: 16,
                        }}
                      >
                        Answer : {displayInfo.answer7}
                      </div>
                      <div
                        style={{
                          marginTop: 20,
                          marginLeft: 20,
                          fontSize: 18,
                          fontWeight: "bold",
                        }}
                      >
                        Eating habits:
                      </div>
                      <div
                        style={{
                          marginTop: 10,
                          marginLeft: 23,
                          fontSize: 16,
                        }}
                      >
                        Answer : {displayInfo.answer8}
                      </div>
                    </div>
                    <div
                      style={{
                        width: "50%",
                        height: "100%",
                      }}
                    >
                      <div
                        style={{
                          marginTop: 20,
                          marginLeft: 20,
                          fontSize: 18,
                          fontWeight: "bold",
                        }}
                      >
                        Stress levels:
                      </div>
                      <div
                        style={{
                          marginTop: 10,
                          marginLeft: 23,
                          fontSize: 16,
                        }}
                      >
                        Answer : {displayInfo.answer9}
                      </div>
                      <div
                        style={{
                          marginTop: 20,
                          marginLeft: 20,
                          fontSize: 18,
                          fontWeight: "bold",
                        }}
                      >
                        Social Habits:
                      </div>
                      <div
                        style={{
                          marginTop: 10,
                          marginLeft: 23,
                          fontSize: 16,
                        }}
                      >
                        Answer : {displayInfo.answer10}
                      </div>
                      <div
                        style={{
                          marginTop: 20,
                          marginLeft: 20,
                          fontSize: 18,
                          fontWeight: "bold",
                        }}
                      >
                        Screen Time habits:
                      </div>
                      <div
                        style={{
                          marginTop: 10,
                          marginLeft: 23,
                          fontSize: 16,
                        }}
                      >
                        Answer : {displayInfo.answer11}
                      </div>
                    </div>
                  </div>
                ) : null}
                {displayInfo.section === "consent" ? <div>consent</div> : null}
                {displayInfo.section === "medical history" ? (
                  <div
                    style={{ width: "100%", height: "100%", display: "flex" }}
                  >
                    <div
                      style={{
                        width: "50%",
                        height: "100%",
                      }}
                    >
                      <div
                        style={{
                          marginTop: 20,
                          marginLeft: 20,
                          fontSize: 18,
                          fontWeight: "bold",
                        }}
                      >
                        Past medical procedures / surgeries:
                      </div>
                      <div
                        style={{
                          marginTop: 10,
                          marginLeft: 23,
                          fontSize: 16,
                        }}
                      >
                        Answer : {displayInfo.answer1}
                      </div>
                      <div
                        style={{
                          marginTop: 20,
                          marginLeft: 20,
                          fontSize: 18,
                          fontWeight: "bold",
                        }}
                      >
                        Recovering from medical procedures / surgeries:
                      </div>
                      <div
                        style={{
                          marginTop: 10,
                          marginLeft: 23,
                          fontSize: 16,
                        }}
                      >
                        Answer : {displayInfo.answer2}
                      </div>
                      <div
                        style={{
                          marginTop: 20,
                          marginLeft: 20,
                          fontSize: 18,
                          fontWeight: "bold",
                        }}
                      >
                        Any prescribed medicine:
                      </div>
                      <div
                        style={{
                          marginTop: 10,
                          marginLeft: 23,
                          fontSize: 16,
                        }}
                      >
                        Answer : {displayInfo.answer3}
                      </div>
                      <div
                        style={{
                          marginTop: 20,
                          marginLeft: 20,
                          fontSize: 18,
                          fontWeight: "bold",
                        }}
                      >
                        Family medical condition history:
                      </div>
                      <div
                        style={{
                          marginTop: 10,
                          marginLeft: 23,
                          fontSize: 16,
                        }}
                      >
                        Answer : {displayInfo.answer4}
                      </div>
                      <div
                        style={{
                          marginTop: 20,
                          marginLeft: 20,
                          fontSize: 18,
                          fontWeight: "bold",
                        }}
                      >
                        Major / Chronic conditions:
                      </div>
                      <div
                        style={{
                          marginTop: 10,
                          marginLeft: 23,
                          fontSize: 16,
                        }}
                      >
                        Answer : {displayInfo.answer5}
                      </div>
                      <div
                        style={{
                          marginTop: 20,
                          marginLeft: 20,
                          fontSize: 18,
                          fontWeight: "bold",
                        }}
                      >
                        condition Info:
                      </div>
                      <div
                        style={{
                          marginTop: 10,
                          marginLeft: 23,
                          fontSize: 16,
                        }}
                      >
                        Answer : {displayInfo.answer6}
                      </div>
                    </div>
                    <div
                      style={{
                        width: "50%",
                        height: "100%",
                      }}
                    >
                      <div
                        style={{
                          marginTop: 20,
                          marginLeft: 20,
                          fontSize: 18,
                          fontWeight: "bold",
                        }}
                      >
                        Other conditions:
                      </div>
                      <div
                        style={{
                          marginTop: 10,
                          marginLeft: 23,
                          fontSize: 16,
                        }}
                      >
                        Answer : {displayInfo.answer7}
                      </div>
                      <div
                        style={{
                          marginTop: 20,
                          marginLeft: 20,
                          fontSize: 18,
                          fontWeight: "bold",
                        }}
                      >
                        More Info about condition:
                      </div>
                      <div
                        style={{
                          marginTop: 10,
                          marginLeft: 23,
                          fontSize: 16,
                        }}
                      >
                        Answer : {displayInfo.answer8}
                      </div>
                      <div
                        style={{
                          marginTop: 20,
                          marginLeft: 20,
                          fontSize: 18,
                          fontWeight: "bold",
                        }}
                      >
                        Addictions:
                      </div>
                      <div
                        style={{
                          marginTop: 10,
                          marginLeft: 23,
                          fontSize: 16,
                        }}
                      >
                        Answer : {displayInfo.answer9}
                      </div>
                    </div>
                  </div>
                ) : null}
                {displayInfo.section === "occupational" ? (
                  <div style={{ width: "100%", height: "100%" }}>
                    <div
                      style={{
                        marginTop: 20,
                        marginLeft: 20,
                        fontSize: 18,
                        fontWeight: "bold",
                      }}
                    >
                      Employment status:
                    </div>
                    <div
                      style={{
                        marginTop: 10,
                        marginLeft: 23,
                        fontSize: 16,
                      }}
                    >
                      Answer : {displayInfo.answer1}
                    </div>
                    <div
                      style={{
                        marginTop: 10,
                        marginLeft: 20,
                        fontSize: 18,
                        fontWeight: "bold",
                      }}
                    >
                      Industry :
                    </div>
                    <div
                      style={{
                        marginTop: 10,
                        marginLeft: 23,
                        fontSize: 16,
                      }}
                    >
                      {" "}
                      Answer : {displayInfo.answer2}
                    </div>
                  </div>
                ) : null}
                {displayInfo === "section21" ? (
                  <div style={{ width: "100%", height: "100%" }}>
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        overflowY: "scroll",
                        overflowX: "hidden",
                      }}
                    >
                      <div
                        style={{
                          width: "90%",
                          fontWeight: "bold",
                          fontSize: 20,
                          marginLeft: 90,
                          marginTop: 25,
                        }}
                      >
                        Section 21 application
                      </div>
                      <div style={{ width: "90%", marginTop: 20 }}>
                        1. Supporting Documents Required:
                      </div>

                      <div style={{ width: "90%" }}> • Copy of ID</div>

                      <div
                        style={{
                          width: "90%",
                          marginTop: 20,
                          fontWeight: "bold",
                        }}
                      >
                        <TextInputField
                          labelTitle={"Title"}
                          invert={true}
                          onChange={(event) => setTitle(event.target.value)}
                          mini={true}
                          size={"90%"}
                          value={title}
                          readOnly={section21Data}
                        />
                        <TextInputField
                          labelTitle={"Full names"}
                          invert={true}
                          onChange={(event) => setFullName(event.target.value)}
                          mini={true}
                          size={"90%"}
                          value={fullName}
                          readOnly={section21Data}
                        />
                        <TextInputField
                          labelTitle={"Surname"}
                          invert={true}
                          onChange={(event) => setSurname(event.target.value)}
                          mini={true}
                          size={"90%"}
                          value={surname}
                          readOnly={section21Data}
                        />
                        <TextInputField
                          labelTitle={"Id number"}
                          invert={true}
                          onChange={(event) => setIdNumber(event.target.value)}
                          mini={true}
                          value={idNumber}
                          size={"90%"}
                          readOnly={section21Data}
                        />
                        <TextInputField
                          labelTitle={"Occupation"}
                          invert={true}
                          onChange={(event) =>
                            setOccupation(event.target.value)
                          }
                          mini={true}
                          size={"90%"}
                          value={occupation}
                          readOnly={section21Data}
                        />
                        <TextInputField
                          labelTitle={"Age"}
                          invert={true}
                          onChange={(event) => setAge(event.target.value)}
                          mini={true}
                          size={"90%"}
                          value={age}
                          readOnly={section21Data}
                        />
                        <TextInputField
                          labelTitle={"Gender"}
                          invert={true}
                          onChange={(event) => setGender(event.target.value)}
                          mini={true}
                          size={"90%"}
                          value={gender}
                          readOnly={section21Data}
                        />
                        <TextInputField
                          labelTitle={"Weigth in Kg"}
                          invert={true}
                          onChange={(event) => setWeight(event.target.value)}
                          mini={true}
                          value={weight}
                          size={"90%"}
                          readOnly={section21Data}
                        />
                        <TextInputField
                          labelTitle={"height in cm"}
                          invert={true}
                          onChange={(event) =>
                            setHeightInCm(event.target.value)
                          }
                          mini={true}
                          size={"90%"}
                          value={heightInCm}
                          readOnly={section21Data}
                        />
                        <TextAreaInput
                          labelTitle={"Address"}
                          color={BlackAndWhite.primary}
                          invert={true}
                          onChange={(event) => setAddress(event.target.value)}
                          mini={true}
                          size={"90%"}
                          value={address}
                          readOnly={section21Data}
                        />
                        <TextInputField
                          labelTitle={"Postal code"}
                          invert={true}
                          onChange={(event) =>
                            setPostalCode(event.target.value)
                          }
                          mini={true}
                          size={"90%"}
                          value={postalCode}
                          readOnly={section21Data}
                        />
                        <TextInputField
                          labelTitle={"Cell number"}
                          invert={true}
                          onChange={(event) =>
                            setCellNumber(event.target.value)
                          }
                          mini={true}
                          size={"90%"}
                          value={cellNumber}
                          readOnly={section21Data}
                        />
                        <TextInputField
                          labelTitle={"Alternate number"}
                          invert={true}
                          onChange={(event) =>
                            setAlternateNumber(event.target.value)
                          }
                          mini={true}
                          size={"90%"}
                          value={alternateNumber}
                          readOnly={section21Data}
                        />
                        <TextInputField
                          labelTitle={"Email address"}
                          invert={true}
                          onChange={(event) =>
                            setEmailAddress(event.target.value)
                          }
                          mini={true}
                          size={"90%"}
                          value={emailAddress}
                          readOnly={section21Data}
                        />
                        <TextAreaInput
                          labelTitle={
                            "Diagnosis – Full description including severity, staging and prognosis where applicable: Example: Chronic Pain, Anxiety, Fibromyalgia etc.– Please give a full description."
                          }
                          color={BlackAndWhite.primary}
                          invert={true}
                          onChange={(event) => setDiagnosis(event.target.value)}
                          mini={true}
                          size={"90%"}
                          value={diagnosis}
                          readOnly={section21Data}
                        />
                        <TextAreaInput
                          labelTitle={
                            "Details of current treatment regimen for the abovediagnosis. Include medical, surgical and other treatment: Example: Aspirin, Ibuprofen, Naproxen, Serotonin and Norepinephrine."
                          }
                          color={BlackAndWhite.primary}
                          invert={true}
                          onChange={(event) =>
                            setTreatmentDetails(event.target.value)
                          }
                          mini={true}
                          size={"90%"}
                          value={treatmentDetails}
                          readOnly={section21Data}
                        />
                        <TextAreaInput
                          labelTitle={
                            "Do you suffer from any other conditions not yet mentioned? If yes, please specify as well as current treatment. Example: High Blood Pressure, Cholesterol, Diabetes etc."
                          }
                          color={BlackAndWhite.primary}
                          invert={true}
                          onChange={(event) =>
                            setOtherConditions(event.target.value)
                          }
                          mini={true}
                          size={"90%"}
                          value={otherConditions}
                          readOnly={section21Data}
                        />
                        <TextInputField
                          labelTitle={"Do you smoke Cannabis?"}
                          invert={true}
                          onChange={(event) =>
                            setDoYouSmokeCannabis(event.target.value)
                          }
                          mini={true}
                          size={"90%"}
                          value={doYouSmokeCannabis}
                          readOnly={section21Data}
                        />
                        <TextInputField
                          labelTitle={"Do you use Cannabis in any other form?"}
                          invert={true}
                          onChange={(event) =>
                            setAnyOtherform(event.target.value)
                          }
                          mini={true}
                          size={"90%"}
                          value={anyOtherForm}
                          readOnly={section21Data}
                        />
                        <TextInputField
                          labelTitle={"Specify"}
                          invert={true}
                          onChange={(event) => setSpecify(event.target.value)}
                          mini={true}
                          size={"90%"}
                          value={specify}
                          readOnly={section21Data}
                        />
                        <div style={{ marginTop: 40 }}>
                          Store Collection point request
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            width: "100%",
                          }}
                        >
                          <BaseButtons
                            label={store ? store.storeName : "loading"}
                            mini={true}
                            size={"93%"}
                          />
                        </div>

                        {/* <TextInputField
              labelTitle={"Store Name"}
              invert={true}
              // onChange={(event) => setAnswer1(event.target.value)}
              mini={true}
              size={"90%"}
              value={store ? store.storeName : "loading"}
            /> */}
                        <TextAreaInput
                          readOnly={section21Data}
                          labelTitle={"Store Address"}
                          color={BlackAndWhite.primary}
                          invert={true}
                          // onChange={(event) => setAnswer1(event.target.value)}
                          mini={true}
                          value={
                            section21Data
                              ? section21Data.storeAddress
                              : store
                              ? store.unitNumber +
                                " " +
                                store.streetAddress +
                                ", " +
                                store.suburb +
                                ", " +
                                store.city +
                                ", " +
                                store.postalCode
                              : "loading"
                          }
                          size={"90%"}
                        />
                        <div
                          style={{
                            color: BlackAndWhite.primary,
                            marginTop: 20,
                          }}
                        >
                          Status
                          <div style={{ marginTop: 5, fontWeight: "normal" }}>
                            {currentStatus}
                          </div>
                        </div>
                        <div style={{ marginTop: 20 }}>
                          Valid Until
                          <div style={{ marginTop: 5, fontWeight: "normal" }}>
                            {validUntil ? validUntil : "pending review"}
                          </div>
                        </div>
                        {/* <div style={{ minHeight: 20 }} /> */}

                        <div style={{ minHeight: 20 }} />
                      </div>
                    </div>
                  </div>
                ) : null}
                {displayInfo === "Prescriptions" ? (
                  <>
                    {selectedPrescription === "Approved" ? (
                      data ? (
                        data.data.map((prescription, index) => {
                          return (
                            <div
                              key={index}
                              style={{
                                width: "100%",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <NewPrescriptionCard
                                width={width}
                                patientNo={
                                  prescription ? prescription.id : "loading"
                                }
                                patientId={
                                  prescription
                                    ? prescription.patientId
                                    : "loading"
                                }
                                doctor={
                                  prescription ? prescription.doctor : "loading"
                                }
                                prescriptionNo={
                                  prescription
                                    ? prescription.prescriptionNum
                                    : "loading"
                                }
                                createdDate={
                                  prescription ? prescription.date : "loading"
                                }
                                validUntil={
                                  prescription
                                    ? prescription.validUntil
                                    : "loading"
                                }
                                status={
                                  prescription
                                    ? prescription.approved
                                    : "loading"
                                }
                                diagonosis={
                                  prescription
                                    ? prescription.diagnosis
                                    : "loading"
                                }
                                prescribed={
                                  prescription
                                    ? prescription.prescription
                                    : "loading"
                                }
                              />
                            </div>
                          );
                        })
                      ) : (
                        <div
                          style={{
                            marginTop: 50,
                            width: "100%",
                            textAlign: "center",
                          }}
                        >
                          No History
                        </div>
                      )
                    ) : null}
                    {selectedPrescription === "Pending" ? (
                      data ? (
                        data.dataPending.map((prescription, index) => {
                          return (
                            <div
                              key={index}
                              style={{
                                width: "100%",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <NewPrescriptionCard
                                patientNo={
                                  prescription ? prescription.id : "loading"
                                }
                                patientId={
                                  prescription
                                    ? prescription.patientId
                                    : "loading"
                                }
                                doctor={
                                  prescription ? prescription.doctor : "loading"
                                }
                                prescriptionNo={
                                  prescription
                                    ? prescription.prescriptionNum
                                    : "loading"
                                }
                                createdDate={
                                  prescription ? prescription.date : "loading"
                                }
                                validUntil={
                                  prescription
                                    ? prescription.validUntil
                                    : "loading"
                                }
                                status={
                                  prescription
                                    ? prescription.approved
                                    : "loading"
                                }
                                diagonosis={
                                  prescription
                                    ? prescription.diagnosis
                                    : "loading"
                                }
                                prescribed={
                                  prescription
                                    ? prescription.prescription
                                    : "loading"
                                }
                              />
                            </div>
                          );
                        })
                      ) : (
                        <div
                          style={{
                            marginTop: 50,
                            width: "100%",
                            textAlign: "center",
                          }}
                        >
                          No History
                        </div>
                      )
                    ) : null}
                    {selectedPrescription === "Declined" ? (
                      data ? (
                        data.dataDeclined.map((prescription, index) => {
                          return (
                            <div
                              key={index}
                              style={{
                                width: "100%",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <NewPrescriptionCard
                                width={width}
                                patientNo={
                                  prescription ? prescription.id : "loading"
                                }
                                patientId={
                                  prescription
                                    ? prescription.patientId
                                    : "loading"
                                }
                                doctor={
                                  prescription ? prescription.doctor : "loading"
                                }
                                prescriptionNo={
                                  prescription
                                    ? prescription.prescriptionNum
                                    : "loading"
                                }
                                createdDate={
                                  prescription ? prescription.date : "loading"
                                }
                                validUntil={
                                  prescription
                                    ? prescription.validUntil
                                    : "loading"
                                }
                                status={
                                  prescription
                                    ? prescription.approved
                                    : "loading"
                                }
                                diagonosis={
                                  prescription
                                    ? prescription.diagnosis
                                    : "loading"
                                }
                                prescribed={
                                  prescription
                                    ? prescription.prescription
                                    : "loading"
                                }
                              />
                            </div>
                          );
                        })
                      ) : (
                        <div
                          style={{
                            marginTop: 50,
                            width: "100%",
                            textAlign: "center",
                          }}
                        >
                          No History
                        </div>
                      )
                    ) : null}
                    {selectedPrescription === "Expired" ? (
                      data ? (
                        data.dataExpired.map((prescription, index) => {
                          return (
                            <div
                              key={index}
                              style={{
                                width: "100%",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <NewPrescriptionCard
                                width={width}
                                patientNo={
                                  prescription ? prescription.id : "loading"
                                }
                                patientId={
                                  prescription
                                    ? prescription.patientId
                                    : "loading"
                                }
                                doctor={
                                  prescription ? prescription.doctor : "loading"
                                }
                                prescriptionNo={
                                  prescription
                                    ? prescription.prescriptionNum
                                    : "loading"
                                }
                                createdDate={
                                  prescription ? prescription.date : "loading"
                                }
                                validUntil={
                                  prescription
                                    ? prescription.validUntil
                                    : "loading"
                                }
                                status={
                                  prescription
                                    ? prescription.approved
                                    : "loading"
                                }
                                diagonosis={
                                  prescription
                                    ? prescription.diagnosis
                                    : "loading"
                                }
                                prescribed={
                                  prescription
                                    ? prescription.prescription
                                    : "loading"
                                }
                              />
                            </div>
                          );
                        })
                      ) : (
                        <div
                          style={{
                            marginTop: 50,
                            width: "100%",
                            textAlign: "center",
                          }}
                        >
                          No History
                        </div>
                      )
                    ) : null}
                  </>
                ) : null}
              </>
            ) : null}
          </div>
        </div>
        <div style={{ position: "absolute", top: 20, left: 20 }}>
          <CloseButton
            label={"X"}
            onClick={() => {
              setSelectedPatient(null);
              setPatientPop(false);
              setDisplayInfo(medicalCheck[0]);
            }}
          />
        </div>
        <LoadingPopUp display={patientInfo ? false : true} />
      </div>
    </div>
  );
};

export default PatientPopUp;
